import type {
  BedsFilter,
  SortOrder,
  PropertyOperation,
  PropertyStatus,
  PropertyType,
  BathsFilter,
} from "@/types/filter.types";

// src/lib/constants.ts
export const SPHERE_RADIUS = 2500;

export const PROPERTY_TYPES: PropertyType[] = [
  "apartment",
  "house",
  "office",
  "commercial",
  "land",
  "garage",
  "other",
];
export const OPERATION_TYPES: PropertyOperation[] = [
  "sale",
  "rent",
  "temporary_rent",
];
export const PROPERTY_STATUSES: PropertyStatus[] = [
  "available",
  "reserved",
  "sold",
  "rented",
];
export const BATHS_OPTIONS: { value: BathsFilter; key: string }[] = [
  { value: null, key: "any" }, 
  { value: 1, key: "1+" },
  { value: 2, key: "2+" },
  { value: 3, key: "3+" },
  { value: 4, key: "4+" },
]
export const BEDS_OPTIONS: { value: BedsFilter; key: string }[] = [
  { value: null, key: "any" }, 
  { value: 1, key: "1+" },
  { value: 2, key: "2+" },
  { value: 3, key: "3+" },
  { value: 4, key: "4+" },
];
export const SORT_OPTIONS: { value: SortOrder; key: string }[] = [
  { value: "newest", key: "sort_newest" },
  { value: "oldest", key: "sort_oldest" },
  { value: "price_asc", key: "sort_price_asc" },
  { value: "price_desc", key: "sort_price_desc" },
];

export const STATUS_BADGE: Record<PropertyStatus, string> = {
  available: "bg-emerald-500/90 text-white",
  reserved: "bg-amber-500/90 text-amber-950",
  sold: "bg-rose-500/90 text-white",
  rented: "bg-sky-500/90 text-white",
};
export const STATUS_DOT: Record<PropertyStatus, string> = {
  available: "bg-emerald-400",
  reserved: "bg-amber-400",
  sold: "bg-rose-400",
  rented: "bg-sky-400",
};

export const LOCALE_MAP: Record<string, string> = {
  en: "en-US",
  es: "es-AR",
  pt: "pt-PT",
  fr: "fr-FR",
  it: "it-IT",
};
